// audio.ts
// Narration per language. German recordings live in public/audio/de/ under
// the same file names as the English ones in public/audio/. A German file is
// used only if it exists (see audioManifest.generated.ts); otherwise the
// English recording plays.
import { getLang, Lang } from "./lang";
import { AUDIO_AVAILABLE } from "./audioManifest.generated";

/** URL of the narration file for the current (or given) language. */
export function audioUrl(path: string, lang: Lang = getLang()): string {
  if (lang === "en") return path;
  const file = path.replace(/^\/audio\//, "");
  return AUDIO_AVAILABLE[lang]?.includes(file) ? `/audio/${lang}/${file}` : path;
}

/** True when the given file has a recording in the current language. */
export function hasLocalAudio(path: string, lang: Lang = getLang()): boolean {
  return lang === "en" || audioUrl(path, lang) !== path;
}

/** `new Audio(path)` in the current language, falling back to English. */
export function localAudio(path: string): HTMLAudioElement {
  return new Audio(audioUrl(path));
}
